import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceTemplatesRulesComponent } from "./maintenance-templates-rules.component";
import { ListTemplatesRulesComponent } from "./list-templates-rules/list-templates-rules.component";
import { CreateEditTemplatesRulesComponent } from "./create-edit-templates-rules/create-edit-templates-rules.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesTemplatesRules: Routes = [
  {
    path: "",
    component: MaintenanceTemplatesRulesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListTemplatesRulesComponent,
      },
      {
        path: "creacion",
        component: CreateEditTemplatesRulesComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditTemplatesRulesComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesTemplatesRules)],
  exports: [RouterModule],
})
export class TemplatesRulesRoutingModule {}
